<template>
  <div>
    <Breadcrumbs main="Rutas" title="Editar Ruta" v-if="objectId"/>
    <Breadcrumbs main="Rutas" title="Agregar Ruta" v-else/>
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="row mb-2" style="font-size: 22px">
                <div class="col-4 text-center">
                  <span class="badge badge-primary"><i class="fa fa-map-marker"> Total de despachos: {{totalMarkers}}</i></span>
                </div>
                <div class="col-4 text-center">
                  <span class="badge badge-warning"><i class="fa fa-map-marker"> Total de despachos disponibles: {{subtractDispatch}}</i></span>
                </div>
                <div class="col-4 text-center">
                  <span class="badge badge-success"><i class="fa fa-map-marker"> Total de despachos seleccionados: {{totalMarkerSelected}}</i></span>
                </div>
              </div>
              <div class="pull-right">
                <b-button class="mr-2" variant="primary" size="sm" v-on:click="reloadTable">
                  <i class="fa fa-refresh"></i> Actualizar
                </b-button>
              </div>
            </div>
            <div class="card-body">
              <p v-if="objectId">Los despachos que se encuentran en estado no disponible, es debido a que están asignadas a otra ruta y ésta no ha sido iniciada. Solamente puedes agregar/eliminar los despachos disponibles y los que están asignados a la ruta seleccionada.</p>
              <form class="form-inline d-flex mx-1 justify-content-end"
                    @submit.stop.prevent="">
                <div class="input-group">
                  <input type="search" placeholder="Buscar" class="form-control"
                         v-model="datatableConfig.quickSearch" v-on:change="doSearch">
                  <div class="input-group-append">
                    <button type="submit" class="btn btn-outline-secondary">
                      <i class="mdi mdi-magnify" /> Buscar
                    </button>
                  </div>
                </div>
              </form>
              <div class="datatable-vue" v-if="isLoaded">
                <vdtnet-table
                    ref="table"
                    :fields="datatableConfig.fields"
                    :opts="datatableConfig.options"
                    @setCheckbox="setCheckbox"
                >
                </vdtnet-table>
              </div>
              <div class="row mb-3" v-if="totalMarkerSelected > 0">
                <div class="col-2">
                  <button type="button" class="btn m-t-15 btn-success"><i class="fa fa-map-marker"></i>
                    {{totalMarkerSelected}} entrega(s)</button>
                </div>
                <div class="col-2">
                  <button type="button" class="btn btn-primary m-t-15" v-on:click="displayModalInfoDispatch(form)"><i class="fa fa-info"></i> Ver Despacho(s)</button>
                </div>
                <div class="col-4">
                  <label>Vehículo (requerido)</label>
                  <multiselect placeholder="Selecciona un vehículo"
                               label="full_name" track-by="id"
                               deselectLabel="Click para eliminar" selectLabel="Seleccionar"
                               v-model="form.vehicle.value" :options="form.vehicle.options"
                               :searchable="true" :close-on-select="true" :show-labels="true" :allow-empty="false">
                    <template slot="noResult">No se encontraron elementos, por favor, cambie el filtro de búsqueda.</template>
                  </multiselect>
                  <b-form-invalid-feedback :state="form.vehicle.is_valid">{{form.vehicle.message_error}}</b-form-invalid-feedback>
                </div>
                <div class="col-4">
                  <label>Conductor (requerido)</label>
                  <multiselect placeholder="Selecciona un conductor"
                               label="full_name" track-by="id"
                               deselectLabel="Click para eliminar" selectLabel="Seleccionar"
                               v-model="form.worker.value" :options="form.worker.options"
                               :searchable="true" :close-on-select="true" :show-labels="true" :allow-empty="false">
                    <template slot="noResult">No se encontraron elementos, por favor, cambie el filtro de búsqueda.</template>
                  </multiselect>
                  <b-form-invalid-feedback :state="form.worker.is_valid">{{form.worker.message_error}}</b-form-invalid-feedback>
                </div>
              </div>
              <b-button type="button" variant="success" @click="onSubmit" v-if="totalMarkerSelected > 0 && (objectId === null || objectId === undefined)">Agregar Ruta</b-button>
              <b-button type="button" variant="success" @click="onSubmit" v-if="totalMarkerSelected > 0 && objectId">Modificar Ruta</b-button>
              <b-button type="button" variant="warning" class="ml-1" :to="{'name': 'RouteList'}">Volver</b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="info-dispatch" centered size="lg" title="Despachos de la ruta" ok-title="Cerrar" ok-only class="theme-modal">
      <b-row>
        <b-col md="12">
          <b-input-group class="datatable-btn">
            <b-form-input v-model="datatableOptions.filter" placeholder="Buscar..."></b-form-input>
          </b-input-group>
        </b-col>
      </b-row>
      <div class="table-responsive datatable-vue">
        <b-table
            show-empty
            stacked="md"
            :items="datatableOptions.items"
            :fields="datatableOptions.tablefields"
            :filter="datatableOptions.filter"
            :current-page="datatableOptions.currentPage"
            :per-page="datatableOptions.perPage"
            @filtered="onFiltered"
        >
          <template v-slot:cell(client)="data">
            {{data.item.client.business_name}}
          </template>
          <template v-slot:cell(dispatch_client)="data">
            {{data.item.name}}
          </template>
          <template v-slot:cell(phone)="data">
            <span v-if="data.item.phone">{{data.item.phone}}</span>
            <span v-else>No proporcionado.</span>
          </template>
        </b-table>
      </div>

      <b-col md="6" class="my-1">
        <b-pagination
            v-model="datatableOptions.currentPage"
            :total-rows="datatableOptions.totalRows"
            :per-page="datatableOptions.perPage"
            class="my-0"
        ></b-pagination>
      </b-col>
    </b-modal>
    <!-- Container-fluid Ends-->
  </div>
</template>

<script>
import $ from 'jquery';
window.jQuery = $;
import VdtnetTable from 'vue-datatables-net';
import 'datatables.net-bs4';
import utils from '../../../utils';
import Multiselect from "vue-multiselect";
import axios from "axios";

export default {
  components: {
    VdtnetTable,
    Multiselect,
  },
  data(){
    return{
      objectId: null,
      isLoaded: false,
      //  TOTAL DE MARCADORES
      totalMarkers: 0,
      // TOTAL MARCADORES SELCCIONADOS
      totalMarkerSelected: 0,
      datatableConfig : {
        options: {
          lengthMenu: [10, 25, 50],
          pageLength: 10,
          lengthChange: false,
          processing: true,
          serverSide: true,
          searchDelay: 500,
          fixedHeader: true,
          responsive: true,
          ajax: {
            // FILTRO LOS ESTADOS QUE PUEDEN VOLVER A SER ASIGNADOS
            url: axios.defaults.baseURL + '/api/inventory/v1.0/dispatch/?format=datatables&status__in[]=4&status__in[]=50&status__in[]=60&status__in[]=250',
            type: "GET",
            headers: {
              Authorization: 'JWT ' + localStorage.getItem('token')
            },
            dataSrc: (json) => {
              this.totalMarkers = json['recordsTotal'];
              return json['data'];
            }
          },
          language: {
            decimal: "",
            emptyTable: "No hay información",
            info: "Mostrando _START_ a _END_ de _TOTAL_ Entradas",
            infoEmpty: "Mostrando 0 to 0 of 0 Entradas",
            infoFiltered: "(Filtrado de _MAX_ total entradas)",
            infoPostFix: "",
            thousands: ",",
            lengthMenu: "Mostrar _MENU_ Entradas",
            loadingRecords: "Cargando...",
            processing: "Procesando...",
            search: "Buscar:",
            zeroRecords: "Sin resultados encontrados",
            paginate: {
              first: "Primero",
              last: "Ultimo",
              next: "Siguiente",
              previous: "Anterior"
            }
          },
          "drawCallback": function () {
            // const num_row = $('.dataTables_length');
            $('div.vdtnet-container').removeClass('table-responsive');
            // num_row.find('select').removeClass('custom-select form-control');
            $('.dataTables_paginate').addClass('pull-right mt-2');
            $('.dataTables_info').addClass('mt-2');
            // GENERAMOS LA TABLA
            const table = $(this);
            // OBTENEMOS EL TBODY
            const tbody = table.find('tbody');
            // OBTENEMOS EL TFOOT
            const tfoot = table.find('tfoot');
            // SI ES QUE NO HAY LO AGREMAOS
            if(tfoot.length === 0){
              // OBTENGOEL TOTAL DE COLUMNAS
              const totalTH = table.find('thead th').length;
              // INSERTAMOS EL TFOOT
              tbody.after('<tfoot>\n' +
                  '            <tr>\n' +
                  '                <th></th>\n'.repeat(totalTH) +
                  '            </tr>\n' +
                  '        </tfoot>');
            }
          },
          "initComplete": function (){
            // COLUMNAS PARA APLICAR EL SELECT
            const selectFilter = [7];
            const table = this;
            table.api().columns(selectFilter).every( function (){
              const column = this;
              const columnJquery = $(table).find('tfoot th')[column[0][0]];
              const select = $('<select><option value=""></option></select>').appendTo( $(columnJquery).empty())
                  .on( 'change', function () {
                    const val = $.fn.dataTable.util.escapeRegex(
                        $(this).val()
                    );
                    column
                        .search( val ? val : '', true, false )
                        .draw();
                  });
              // FILTRAMOS POR POSICIÓN DE LA COLUMNA ESTADO
              if(column[0][0] === 7){
                // RECORREMOS TODOS LOS ESTADOS Y LOS AGREGAMOS AL SELECT
                for (let i = 0; i < utils.statusDispatch.length; i++ ){
                  select.append( '<option value="' + utils.statusDispatch[i]['id'] + '">' + utils.statusDispatch[i]['name'] +'</option>' );
                }
              }
            });
          },
        },
        fields: {
          check: {
            data: 'check',
            label: 'Seleccionar',
            isLocal: true,
            render: (data, type, row) => {
              let checked = '';
              if(this.isChecked(row['id'])){
                checked = 'checked';
              }
              return `<input type="checkbox" ${checked} data-action="setCheckbox" />`;
            }
          },
          code: {
            name: 'code',
            label: 'Código',
            data: 'code',
            sortable: true,
          },
          tracking_code: {
            name: 'tracking_code',
            label: 'Código de tracking',
            data: 'tracking_code',
            sortable: true,
          },
          client: {
            name: 'client__business_name',
            label: 'Cliente',
            data: 'client.business_name'
          },
          date_register: {
            name: 'date_register',
            label: 'Fecha de registro',
            data: 'date_register'
          },
          dispatch_client: {
            name: 'name',
            label: 'Cliente a despacho',
            data: 'name'
          },
          address: {
            name: 'address',
            label: 'Dirección',
            data: 'address'
          },
          status: {
            name: 'status',
            label: 'Estado',
            data: 'status',
            render: function (data, type, row) {
              let status;
              const name = utils.statusDispatch.find(options => options['id'] === row['status'])['name'];
              // PENDIENTE RUTA ASIGNADA, EM DESPACHO
              if(['4', '280', '220'].includes(row['status'])){
                status = `<span class="badge badge-primary">${name}</span>`;
              }// ENTREGADO
              else if (row['status'] === '1'){
                status = `<span class="badge badge-success">${name}</span>`;
              }
              // DESCONOCIDO, NO HAY QUIEN RECIBA, 1 IDA
              else if(['50', '60', '250'].includes(row['status'])){
                status = `<span class="badge badge-alert">${name}</span>`;
              } // ANULADO
              else if (row['status'] === '0'){
                status = `<span class="badge badge-warning">${name}</span>`;
              }  // DIRECCIÓN INCOMPLETA - NO HAY NÚMERO - CAMBIO DE DOMICILIO - CAMBIO DOMICILIO - REHUSADA - 2 ida
              else if (utils.syncStatusDispatch.includes(row['status'])){
                status = `<span class="badge badge-danger">${name}</span>`;
              }else{
                status = row['status'];
              }
              return status;
            }
          },
          id: {
            data: 'id',
            visible: false,
            searchable: false,
          },
          route: {
            data: 'route',
            visible: false,
            searchable: false,
          },
          voucher: {
            data: 'voucher',
            visible: false,
            searchable: false,
          },
          phone: {
            data: 'phone',
            visible: false,
            searchable: false,
          },
        },
        quickSearch: '',
      },
      statusDispatch: utils.statusDispatch,
      syncStatusDispatch: utils.syncStatusDispatch,
      datatableOptions: {
        tablefields: [
          { key: 'code', label: 'Código', sortable: true},
          { key: 'tracking_code', label: 'Código de seguimiento', sortable: true},
          { key: 'client', label: 'Cliente', sortable: true},
          { key: 'dispatch_client', label: 'Cliente a despacho', sortable: true},
          { key: 'phone', label: 'Teléfono', sortable: true},
          { key: 'address', label: 'Dirección', sortable: true},
        ],
        items: null,
        filter: null,
        totalRows: 1,
        currentPage: 1,
        perPage: 10,
      },
      // DATOS DEL DESPACHO A MODIFICAR
      dispatchEdit: null,
      formDispatchEdit : {
        id: utils.defaultFields(),
        status: utils.defaultFields({
          _type: 'select',
          options: utils.statusDispatchMobile
        }),
        observation: utils.defaultFields()
      },
      formDispatchDelete : {
        id: utils.defaultFields(),
        observation: utils.defaultFields()
      },
      formDispatchVoucherUpload : {
        id: utils.defaultFields(),
        image: utils.defaultFields()
      },
      form: {
        worker: utils.defaultFields({_type: 'select'}),
        vehicle: utils.defaultFields({_type: 'select'}),
        routetrajectory_set: [],
        dispatchsList: []
      }
    }
  },
  beforeDestroy () {
    clearInterval(this.intervalTable);
  },
  async mounted() {
    // OBTENGO LA ID SI ES Q LA HAY
    this.objectId = this.$route.params.objectId;
    // CARGO LOS DATOS
    if(this.objectId){
      await this.loadData(this.objectId);
    }
    // VERIFICO SI DEBO COLOCAR MARCAS POR DEFECTO
    // SI HAY ID
    if (this.objectId !== null && this.objectId !== undefined){
      // CAMBIO LA URL AGRENADO FILTROS
      this.datatableConfig.options.ajax.url = axios.defaults.baseURL + '/api/inventory/v1.0/dispatch/?format=datatables&status__in[]=4&status__in[]=50&status__in[]=60&status__in[]=250&status__in[]=280&routetrajectory__route_id=' + this.objectId;
      // VALIDO SI ES Q PUEDO ASGINAR EL CHECK
      this.datatableConfig.fields.check.render = (data, type, row) => {
        // SI ES DISTINTO A LA RUTA A MODIFICAR Y ES DISTINTO A NULO Y SI TIENE EL ESTADO 280 (RUTA ASIGNADA) NO PODRÁ SER CHECKIADO PORQ ESTÁ ASIGNADO A OTRA RUTA
        if(row['route'] !== this.objectId && row['route'] !== null && row['status'] === '280'){
          return '<span class="badge badge-danger">No disponible</span>';
        }
        let checked = '';
        if(this.isChecked(row['id'])){
          checked = 'checked';
        }
        return `<input type="checkbox" ${checked} data-action="setCheckbox" />`;
      };
    }
    // MANDO LA SEÑAL QUE ESTÁ CARGADO
    this.isLoaded = true;
    this.intervalTable = setInterval(() => {
      this.$refs.table.reload();
    }, utils.timeRefresh * 1000);
    // OBTENGO LOS TRABAJADORES
    await this.getWorker(this.form.worker);
    // OBTENGO A LOS VEHÍCULOS
    await this.getVehicle(this.form.vehicle);
    // SI ES MODIFICABLE, AGREGO AL CONDUCTOR Y AL VEHÍCULO
    if(this.objectId){
      const vehicle = {'full_name': `${this.form.vehicle_array.name.value} (Actual)`, 'id': this.form.vehicle_array.id.value};
      const worker = {'full_name': `${this.form.worker_array.name.value} (Actual)`, 'id': this.form.worker_array.id.value};
      this.form.vehicle.value = vehicle;
      this.form.vehicle.options.push(vehicle);
      this.form.worker.value = worker;
      this.form.worker.options.push(worker);
      delete this.form['vehicle_array'];
      delete this.form['worker_array'];
      console.log(this.form.worker.options);
    }
  },
  methods: {
    async onSubmit(evt){
      // console.log(evt)
      evt.preventDefault();
      // RECORRO CADA FORMULARIO
      let data = [];
      // DATA PARA CADA DICCIONARIO
      let _data = {};
      // GENERAMOS UNA COPIA DEL FORM PARA NO ELIMINAR LA ORIGINAL
      const _form = Object.assign({}, this.form);
      // ELIMINAMOS LA LLAVE LISTA DE DESPACHOS
      await delete _form['dispatchsList'];
      // VEMOS SI ES VÁLIDO
      let is_valid = utils.generateJsonStructure(_form, _data);
      if(is_valid){
        // LO AGREGAMOS A LA DATA
        data.push(_data);
        let _type = 'agregar una ruta';
        let __type = 'agregar';
        if(this.objectId){
          _type = 'modificar una ruta';
          __type = 'modificar';
        }
        this.$swal({
          title: 'Información',
          type: 'info',
          html: `Estás a punto de ${_type}. Al ${__type} <b>bloquearás</b> al conductor con su vehículo, en donde, no podrá ser utilizado hasta que no se haya finalizado/eliminado/detenido la ruta.`,
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          confirmButtonColor: '#28a745',
          confirmButtonText: '<i class="fa fa-thumbs-up"></i> Continuar',
          cancelButtonColor: '#dc3545',
          cancelButtonText: '<i class="fa fa-thumbs-down"></i> Cancelar',
          showLoaderOnConfirm: true,
          preConfirm: async () => {
            if(!this.objectId){
              const path = '/api/route/v1.0/route/';
              await axios.post(path, data).then(async () => {
                // console.log(response);
                await this.$swal({
                  title: 'Agregado',
                  type: 'success',
                  html: `Se han agregado la ruta de manera correcta.`,
                }).then(() => {
                  this.$router.push({'name': 'RouteList'});
                });
              }).catch(async (error) => {
                // ERROR 401 DA CUANDO NO SE ENVÍA EL TOKEN
                console.log(error.response);
                if(error.response.status === 400){
                  utils.generateBackendError(this.form, error.response.data);
                  await this.$swal({
                    title: 'Error',
                    type: 'error',
                    html: `Hay campos que no han sido completados correctamente, por favor, verifica nuevamente el formulario.`,
                  });
                }
              });
            } else {
              const path = `/api/route/v1.0/route/${this.objectId}/`;
              await axios.patch(path, data).then(async () => {
                // console.log(response);
                await this.$swal({
                  title: 'Modificado',
                  type: 'success',
                  html: `Se ha modificado el ruta de manera correcta.`,
                }).then(() => {
                  this.$router.push({'name': 'RouteList'});
                });
              }).catch(async (error) => {
                // ERROR 401 DA CUANDO NO SE ENVÍA EL TOKEN
                console.log(error.response);
                if(error.response.status === 400){
                  utils.generateBackendError(this.form, error.response.data);
                  await this.$swal({
                    title: 'Error',
                    type: 'error',
                    html: `Hay campos que no han sido completados correctamente, por favor, verifica nuevamente el formulario.`,
                  });
                }
              });
            }
          }
        });
      } else {
        this.$swal({
          title: 'Error',
          type: 'error',
          html: `Hay campos que no han sido completados correctamente, por favor, verifica nuevamente el formulario.`,
        });
      }
    },
    isChecked(idObject){
      // SI ESTÁ SELECCIONADO LO AGREGAMOS
      return this.form.dispatchsList.find(item => item['id'] === idObject) !== undefined;
    },
    setCheckbox(row, type, jquery){
      let input = jquery.find('input').first();
      // OBTENGO EL ÍNDICE
      const index = this.form.dispatchsList.findIndex(item => item['id'] === row['id']);
      // SI ES MAYOR SE ELIMINA
      if(index > -1){
        // ELIMINO 1 SELECCIONADO
        this.totalMarkerSelected--;
        this.form.dispatchsList.splice(index, 1);
        this.form.routetrajectory_set.splice(index, 1);
        // ELIMINAMOS EL CHECK
        input.parent().html(input.removeAttr('checked').parent().html());
      } else { // SI NO SE AGREGA
        if ((this.totalMarkerSelected + 1) > utils.maxDispatch) {
          this.$swal({
            title: 'Máximo alcanzado',
            type: 'info',
            html: `Se ha alcanzado el máximo de puntos a seleccionar (${utils.maxDispatch}).`,
          });
          return
        }
        // AGREGO 1 SELECCIONADO
        this.totalMarkerSelected++;
        this.form.dispatchsList.push(row);
        this.form.routetrajectory_set.push(
            {
              dispatch: utils.defaultFields(
                  {
                    value: row['id']
                  }
              )
            }
        );          // SE MARCA EL CHECK
        input.parent().html(input.attr('checked', '').parent().html());
      }
      // this.reloadTable();
    },
    reloadTable() {
      // ELIMINAOS EL INTERVALO
      clearInterval(this.intervalTable);
      // RECARGAMOS
      this.$refs.table.reload();
      // GENERAMOS EL INTERVALO
      this.intervalTable = setInterval(() => {
        this.$refs.table.reload();
      }, utils.timeRefresh * 1000);
    },
    doSearch() {
      this.$refs.table.search(this.datatableConfig.quickSearch);
    },
    displayModalInfoDispatch(form){
      this.datatableOptions.totalRows = form['dispatchsList'].length;
      this.datatableOptions.items = form['dispatchsList'];
      this.$bvModal.show('info-dispatch');
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.datatableOptions.totalRows = filteredItems.length;
      this.datatableOptions.currentPage = 1
    },
    async getWorker(workerField){
      const path = `/api/core/v1.0/worker_profile/`;
      const config = {
        params: {
          user__is_active: true,
          available: true
        }
      };
      await axios.get(path, config).then(async (response) => {
        workerField.options = response.data;
      }).catch((error) => {
        console.log(error.response);
      });
    },
    async getVehicle(vehicleField){
      const path = `/api/route/v1.0/vehicle/`;
      const config = {
        params: {
          available: true
        }
      };
      await axios.get(path, config).then(async (response) => {
        vehicleField.options = response.data;
      }).catch((error) => {
        console.log(error.response);
      });
    },
    async loadData(objectId){
      let data = {};
      let responseData;
      const defaultFieldValues = {
        worker: utils.defaultFields({_type: 'select'}),
        vehicle: utils.defaultFields({_type: 'select'}),
      };
      const path = `/api/route/v1.0/route/${objectId}/`;
      await axios.get(path).then(async (response) => {
        responseData = response.data;
        await utils.loadDataStructure(data, responseData, defaultFieldValues);
      }).catch((error) => {
        console.log(error.response);
      });
      let routetrajectory_set = [];
      data['dispatchsList'] = [];
      // ASIGNAMOS LOS SELECCIONADOS
      data.routetrajectory_set.forEach(item => {
        this.totalMarkerSelected++;
        data['dispatchsList'].push({'id': item['dispatch'].value});
        routetrajectory_set.push(
            {
              dispatch: utils.defaultFields(
                  {
                    value: item['dispatch'].value
                  }
              )
            }
        );
      });
      await this.$set(
          this,
          'form',
          {
            worker: data['worker'],
            worker_array: data['worker_array'],
            vehicle: data['vehicle'],
            vehicle_array: data['vehicle_array'],
            routetrajectory_set: routetrajectory_set,
            dispatchsList: data['dispatchsList']
          }
      );
    }
  },
  computed: {
    subtractDispatch() {
      return this.totalMarkers - this.totalMarkerSelected;
    }
  }
}
</script>

<style>
table img {
  width: 100px;
  height: 100px;
}
.badge-alert {
  color: #FFFFff;
  background-color: #6f42c1;
}
</style>